import { Grid } from '@mui/material';

import { styled } from '#/src/theme';

export const StyledQuestion = styled(Grid)({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
  width: '100%',
  marginBottom: '1rem',
});
